import {
  add_query_arg,
  get_query_arg,
  isDomElementVisible
} from "../js_common/_dzs_helpers";
import {
  DZSWTL_VIEW_AJAX_MAIN_ITEMS_CONTAINER,
  DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER
} from '../config/_dzswtl_constants';
import {hiddenArgumentsForAddress} from "../../../configs/frontend/hidden-arguments-for-address";


export function prepareUrlForFilterChange(queries = {}) {

  var newurl = '';

  // -- eliminate args we don't need from $_GET

  for (let key in hiddenArgumentsForAddress) {
    if(key.indexOf('cookie_')===0){
      newurl = add_query_arg(newurl, hiddenArgumentsForAddress[key], 'NaN');
    }
    newurl = add_query_arg(newurl, hiddenArgumentsForAddress[key], 'NaN');
  }

  return newurl;
}

export function loadScriptZoomsounds() {
  jQuery.getScript(window.dzsap_settings.dzsap_site_url + "wp-content/plugins/dzs-zoomsounds/audioplayer/audioplayer.js", function () {

    setTimeout(()=>{
      // -- give it time to init
      window.dzsap_init('.audioplayer-tobe.auto-init', {
        init_each: true
      });
    },50);


  })
  jQuery('head').append('<link rel="stylesheet" type="text/css" href="' + window.dzsap_settings.dzsap_site_url + "wp-content/plugins/dzs-zoomsounds/audioplayer/audioplayer.css" + '"/>')
}

export function wooTableInitialSetup(selfClass) {


  if (jQuery('.' + DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER).length === 0) {
    if (selfClass.cthis.hasClass('shop-index-1')) {
      selfClass.cthis.addClass(DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER);
    }
  }


  if (selfClass.cthis.hasClass('layout-grid')) {
    selfClass.view_layoutMode = 'grid';
  }

  selfClass['$pagination'] = jQuery('.dzs-woo-table.' + DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER + ' .woo-table--pagination').eq(0);

  if (selfClass.initOptions.address_query_remove_add_to_cart_in_shop_page === 'on') {
    if (get_query_arg(window.location.href, 'add-to-cart')) {

      var newUrl = add_query_arg(window.location.href, 'add-to-cart', 'NaN');
      history.pushState({href: newUrl}, null, newUrl);
    }

  }


  selfClass['pagination_method'] = selfClass.cthis.attr('data-pagination-method');





}

export function loadScriptDZSWTLLightbox(o) {

  window.loading_multi_sharer = true;
  var $ = jQuery;


  setTimeout(function () {

    $('body').append('<div class="dzswtl-main-con skin-default gallery-skin-default transition-slideup "> <div class="overlay-background"></div> <div class="box-mains-con"> <div class="box-main" style=""> <div class="box-main-media-con transition-target"> <div class="close-btn-con"> <svg enable-background="new 0 0 40 40" id="" version="1.1" viewBox="0 0 40 40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M28.1,26.8c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-6.8-6.8l-6.8,6.8c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6.8-6.8l-6.8-6.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.8,6.8l6.8-6.8 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L21.3,20L28.1,26.8z"></path></g><g><path d="M19.9,40c-11,0-20-9-20-20s9-20,20-20c4.5,0,8.7,1.5,12.3,4.2c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.4-1,0.5-1.4,0.2 c-3.2-2.5-7-3.8-11-3.8c-9.9,0-18,8.1-18,18s8.1,18,18,18s18-8.1,18-18c0-3.2-0.9-6.4-2.5-9.2c-0.3-0.5-0.1-1.1,0.3-1.4 c0.5-0.3,1.1-0.1,1.4,0.3c1.8,3.1,2.8,6.6,2.8,10.2C39.9,31,30.9,40,19.9,40z"></path></g></svg></div> <div class="box-main-media type-inlinecontent" style="width: 530px; height: 280px;"><div class=" real-media" style=""><div class="hidden-content share-content" > <div class="social-networks-con"></div> <div class="share-link-con"></div> <div class="embed-link-con"></div> </div> </div> </div> <div class="box-main-under"></div> </div> </div> </div><!-- end .box-mains-con--> </div>');


    $(document).on('click.dzswtl', '.dzswtl-multisharer-but', click_open_embed_ultibox);
    $(document).on('click.dzswtl', '.dzswtl-main-con .close-btn-con,.dzswtl-main-con .overlay-background', function () {

      var _c = $('.dzswtl-main-con').eq(0);

      _c.removeClass('loading-item loaded-item');
    })
  }, 1000);

  function click_open_embed_ultibox() {


    var $wtlLightboxMainCon = $('.dzswtl-main-con').eq(0);


    var stringSocialFeed = '';

    if (window.dzs_social_feed_for_social_networks) {
      stringSocialFeed = window.dzs_social_feed_for_social_networks;
    }


    stringSocialFeed = stringSocialFeed.replace(/{{replacewithdataurl}}/g, $(this).attr('data-url'));

    $wtlLightboxMainCon.find('.social-networks-con').html(stringSocialFeed);


    stringSocialFeed = '';
    if (window.dzs_social_feed_for_share_link) {
      stringSocialFeed = window.dzs_social_feed_for_share_link;
    }


    if (stringSocialFeed) {

      stringSocialFeed = stringSocialFeed.replace(/{{replacewithdataurl}}/g, $(this).attr('data-url'));
      stringSocialFeed = stringSocialFeed.replace('{{replacewithcurrurl}}', window.location.href);
      $wtlLightboxMainCon.find('.share-link-con').html(stringSocialFeed);
    }

    stringSocialFeed = '';
    if (window.dzs_social_feed_for_embed_link) {
      stringSocialFeed = window.dzs_social_feed_for_embed_link;
    }


    if (o.embed_code) {

      if (stringSocialFeed) {
        stringSocialFeed = stringSocialFeed.replace('{{replacewithembedcode}}', htmlEntities(o.embed_code));
        $wtlLightboxMainCon.find('.embed-link-con').html(stringSocialFeed);
      }

    }

    $(document).on('click.dzswtl', '.field-for-view', function () {


      $(this).select();
    });
    setTimeout(function () {

      $wtlLightboxMainCon.addClass('loading-item');
    }, 100);

    setTimeout(function () {
      $wtlLightboxMainCon.addClass('loaded-item');
    }, 200);

    return false;
  }


}

export function getSingletonAjaxContainer() {
  let $ajaxContainer;
  let selector = '.' + DZSWTL_VIEW_AJAX_MAIN_ITEMS_CONTAINER;


  if (jQuery('.dzswtl-main-ajax-target').length) {
    // -- replace all
    selector = '.' + DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER + ' .' + DZSWTL_VIEW_AJAX_MAIN_ITEMS_CONTAINER;
    $ajaxContainer = jQuery(selector);
  } else {

    $ajaxContainer = jQuery(selector).eq(0);

    if (dzswtl_settings.filter_check_if_visible === 'on') {
      if (!isDomElementVisible($ajaxContainer.get(0))) {
        $ajaxContainer = jQuery(selector).eq(1);
      }
    }
  }


  return $ajaxContainer;
}